import React from 'react'
import HomePage from './components/HomePage'
import Navbar from './components/Navbar'

const Home = () => {
  return (
    <>
    <Navbar/>
    <HomePage/>

    </>
  )
}

export default Home